// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2R4u0","actionsCol":"EnrolledClinics_actionsCol__2Heh7"};